import { useEffect, useRef, useState } from 'react'
import QRCode from 'qrcode'

interface Props {
  /** Ровно та строка, которую прочитает кошелёк. */
  value: string
  /** Разрешение холста. Показанный размер задаёт CSS через `className`. */
  size?: number
  className?: string | undefined
}

/**
 * QR-код на canvas.
 *
 * Рисуется локально, а не через внешний генератор: адрес получателя
 * не должен уезжать на чужой сервер — там его можно и подменить
 * в ответе. Уровень коррекции M: адреса Monero длинные, и на высоком
 * уровне код становится настолько плотным, что камера телефона мажет.
 */
export function Qr({ value, size = 512, className }: Props) {
  const ref = useRef<HTMLCanvasElement>(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    const canvas = ref.current
    if (!canvas) return
    let cancelled = false
    QRCode.toCanvas(canvas, value, {
      width: size, margin: 1, errorCorrectionLevel: 'M',
      color: { dark: '#111111', light: '#FFFFFF' },
    })
      .then(() => {
        if (cancelled) return
        // Библиотека проставляет холсту РАЗМЕР В СТИЛЕ, а не только
        // разрешение. Инлайновый стиль сильнее любого класса, и код
        // остаётся размером с разрешение, каким бы его ни просили
        // показать. Снимаем — показанный размер задаёт CSS.
        canvas.style.removeProperty('width')
        canvas.style.removeProperty('height')
        setFailed(false)
      })
      .catch(() => { if (!cancelled) setFailed(true) })
    return () => { cancelled = true }
  }, [value, size])

  if (failed) {
    return (
      <p style={{ color: 'var(--ink-soft)', fontSize: 14, textAlign: 'center', margin: 0 }}>
        Код не отрисовался. Скопируйте адрес кнопкой ниже.
      </p>
    )
  }
  // Холст рисуем крупным, а показываем тем размером, который задаст
  // CSS: в макете он разный на трёх ширинах. Уменьшенный крупный код
  // читается камерой, увеличенный мелкий — нет.
  return (
    <canvas ref={ref} className={className}
            style={{ borderRadius: 12, background: '#FFFFFF' }} />
  )
}
